import "./Profile.scss";
import { theme, Layout, Typography, Spin, Avatar, Tag, Button } from "antd";
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  HomeOutlined,
  IdcardOutlined,
  CalendarOutlined,
  BankOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";


import Utils from "../../utils";

const { Content } = Layout;

const InfoRow = ({ icon, label, value }) => {
  if (!value) return null;
  return (
    <div className="profile-cont__card__info-row">
      <div className="profile-cont__card__info-row__icon">{icon}</div>
      <div className="profile-cont__card__info-row__content">
        <Typography.Text className="profile-cont__card__info-row__content__label">
          {label}
        </Typography.Text>
        <Typography.Text className="profile-cont__card__info-row__content__value">
          {value}
        </Typography.Text>
      </div>
    </div>
  );
};

const formatAddress = (user) => {
  const parts = [user?.address, user?.city, user?.state, user?.zipcode].filter(
    Boolean
  );
  return parts.length > 0 ? parts.join(", ") : "";
};

const statusColorMap = {
  approved: "green",
  pending: "orange",
  rejected: "red",
};

export default function Profile() {
  const { useToken } = theme;
  const { token } = useToken();
  const navigate = useNavigate();
  const { user, loading } = useSelector(
    (state) => state?.auth
  );

  const displayName = user?.is_organization
    ? user?.name || ""
    : `${user?.first_name || ""} ${user?.last_name || ""}`.trim();

  const memberSince = user?.is_organization
    ? Utils.format_date(user?.created_at)
    : Utils.format_date(user?.date_joined);

  const address = user?.is_organization ? formatAddress(user) : "";

  return (
    <Content
        className="profile-cont"
        style={{
          backgroundColor: token?.Layout?.contentBg,
        }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          className="profile-cont__back-btn"
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/"))}>
          Back
        </Button>
        <Spin spinning={loading}>
          <div className="profile-cont__card">
            <div className="profile-cont__card__header">
              <Avatar
                size={120}
                src={user?.picture_url || undefined}
                icon={<UserOutlined style={{ fontSize: "56px" }} />}
                className="profile-cont__card__header__avatar"
              />
              <Typography.Title
                level={2}
                className="profile-cont__card__header__name"
                style={{ color: token?.Typography?.colorPrimaryText }}>
                {displayName}
              </Typography.Title>
              <Typography.Text className="profile-cont__card__header__email">
                {user?.email || ""}
              </Typography.Text>
              {user?.is_organization && user?.status && (
                <Tag
                  color={statusColorMap[user.status] || "default"}
                  className="profile-cont__card__header__status">
                  {user.status.charAt(0).toUpperCase() + user.status.slice(1)}
                </Tag>
              )}
            </div>

            <div className="profile-cont__card__divider" />

            <div className="profile-cont__card__section">
              <Typography.Text
                className="profile-cont__card__section__title"
                style={{ color: token?.Typography?.colorPrimaryText }}>
                {user?.is_organization
                  ? "Organization Details"
                  : "Personal Information"}
              </Typography.Text>

              {user?.is_organization ? (
                <>
                  <InfoRow
                    icon={<BankOutlined />}
                    label="Organization Name"
                    value={user?.name}
                  />
                  <InfoRow
                    icon={<MailOutlined />}
                    label="Email"
                    value={user?.email}
                  />
                  <InfoRow
                    icon={<PhoneOutlined />}
                    label="Phone"
                    value={
                      user?.phone_number
                        ? Utils.format_phone_number(user.phone_number)
                        : ""
                    }
                  />
                  <InfoRow
                    icon={<HomeOutlined />}
                    label="Address"
                    value={address}
                  />
                  <InfoRow
                    icon={<IdcardOutlined />}
                    label="License Number"
                    value={user?.license_number}
                  />
                </>
              ) : (
                <>
                  <InfoRow
                    icon={<UserOutlined />}
                    label="First Name"
                    value={user?.first_name}
                  />
                  <InfoRow
                    icon={<UserOutlined />}
                    label="Last Name"
                    value={user?.last_name}
                  />
                  <InfoRow
                    icon={<MailOutlined />}
                    label="Email"
                    value={user?.email}
                  />
                </>
              )}

              <InfoRow
                icon={<CalendarOutlined />}
                label="Member Since"
                value={memberSince}
              />
            </div>
          </div>
        </Spin>
      </Content>
  );
}
